import { z } from 'zod';

// #131: Tester-Zuweisung per Excel. Vorschau ist zustandslos (Datei → Zeilen), Übernehmen bekommt
// nur die aufgelösten Paare und prüft sie serverseitig neu.
export const TESTER_IMPORT_STATUSES = ['assign', 'unchanged', 'skipped', 'error'] as const;
export type TesterImportStatus = (typeof TESTER_IMPORT_STATUSES)[number];
export const TESTER_IMPORT_REASONS = [
  'unknown_test_number',
  'unknown_tester',
  'not_in_plan_scope',
  'duplicate_in_file',
  'empty_tester',
  'same_tester',
] as const;
export type TesterImportReason = (typeof TESTER_IMPORT_REASONS)[number];

export interface TesterImportRow {
  row_no: number;
  test_number: string;
  tester_raw: string;
  status: TesterImportStatus;
  reason: TesterImportReason | null;
  test_case_id: string | null;
  human_id: string | null;
  title: string | null;
  current_tester: string | null;
  new_tester: { user_id: string; name: string; is_stub: boolean } | null;
}

export interface TesterImportPreview {
  rows: TesterImportRow[];
  counts: Record<TesterImportStatus, number>;
}

export const TesterImportApplySchema = z.object({
  assignments: z
    .array(z.object({ test_case_id: z.string().uuid(), tester_id: z.string().uuid() }))
    .min(1)
    .max(5000),
  also_default: z.boolean(),
});
export type TesterImportApply = z.infer<typeof TesterImportApplySchema>;
